<app-breadcrumb [title]="'Programa PESV'" [items]="['Pesv']" [active_item]="'Programa PESV'"></app-breadcrumb>

<div class="container-fluid programa-form-wrap">
  <div class="card shadow-sm border-0">
    <div class="card-header bg-primary text-white d-flex align-items-center">
      <i class="icofont icofont-file-document me-2"></i>
      <h5 class="mb-0"><strong>PROGRAMA PESV</strong></h5>
    </div>

    <div class="card-body">
      <ul ngbNav #programaTab="ngbNav" [(activeId)]="activeTab" class="nav-tabs">

        <li [ngbNavItem]="1">
          <a ngbNavLink>
            <strong><i class="icofont icofont-plus me-1"></i> REGISTRO DE PROGRAMAS</strong>
          </a>

          <ng-template ngbNavContent>
            <form [formGroup]="programaForm" (ngSubmit)="guardar()" class="pt-3" novalidate>

              <!-- INFORMACIÓN GENERAL -->
              <div class="card border-0 shadow-sm mb-3">
                <div class="card-body">

                  <div class="row g-3">

                    <div class="col-md-3">
                      <label class="form-label text-black">
                        Código del programa: <span class="text-danger">*</span>
                      </label>

                      <input type="text" class="form-control" formControlName="consecutivo"
                        placeholder="Ingrese el código del programa">
                    </div>
                    <div class="col-md-6">
                      <label class="form-label text-black">
                        Tipo de programa: <span class="text-danger">*</span>
                      </label>
                      <div class="input-group">
                        <ng-select class="flex-grow-1" [items]="tiposPrograma" bindLabel="descripcion" bindValue="id"
                          formControlName="tipoPrograma" placeholder="Seleccione..." [clearable]="true">
                        </ng-select>

                        <button class="btn btn-primary" type="button" (click)="abrirModal(modalCrearTipoPrograma)"
                          ngbTooltip="Crear nuevo tipo de programa">
                          <i class="icon-plus"></i>
                        </button>
                      </div>
                    </div>
                     <div class="col-md-3">
                      <label class="form-label text-black">
                        Fecha inicio: <span class="text-danger">*</span>
                      </label>

                      <input type="date" class="form-control" formControlName="fechaInicio" [max]="fechaMaximaInicio"
                        (change)="onFechaInicioChange()">
                    </div>

                    <div class="col-md-3">
                      <label class="form-label text-black">
                        Fecha fin:
                      </label>

                      <input type="date" class="form-control" formControlName="fechaFin" readonly>

                      <small class="text-secondary">
                        Se calcula automáticamente: 1 año después de la fecha de inicio.
                      </small>
                    </div>

                    <div class="col-md-12">
                      <label class="form-label text-black">
                        Objetivo general: <span class="text-danger">*</span>
                      </label>
                      <textarea class="form-control" rows="4" maxlength="2000" formControlName="objetivoGeneral"
                        placeholder="Describa el objetivo general del programa">
          </textarea>
                    </div>

                    <small class="text-secondary">
                      Máximo 2000 caracteres.
                    </small>

                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-center gap-2 mt-4">
                <button type="submit" class="btn btn-primary px-4" [disabled]="guardando">
                  <span *ngIf="!guardando">
                    <i class="icofont icofont-save me-1"></i>
                    {{ modoEdicion ? 'Actualizar' : 'Guardar' }}
                  </span>
                  <span *ngIf="guardando">
                    <span class="spinner-border spinner-border-sm me-1"></span>
                    {{ modoEdicion ? 'Actualizando...' : 'Guardando...' }}
                  </span>
                </button>

                <button type="button" class="btn btn-secondary px-4" *ngIf="modoEdicion" (click)="cancelarEdicion()"
                  [disabled]="guardando">
                  <i class="icofont icofont-close me-1"></i>Cancelar edición
                </button>
              </div>

            </form>
          </ng-template>
        </li>

        <li [ngbNavItem]="2">
          <a ngbNavLink><strong><i class="icofont icofont-listine-dots me-1"></i> LISTADO PROGRAMAS</strong></a>
          <ng-template ngbNavContent>
            <div class="card card-absolute rounded mt-3 border-0 shadow-sm">
              <div class="card-body pt-3">

                <div *ngIf="cargandoListado" class="text-center py-4">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Cargando...</span>
                  </div>
                  <p class="mt-2 mb-0">Cargando programas...</p>
                </div>

                <div class="row mb-3 align-items-center" *ngIf="!cargandoListado">
                  <div class="col-md-3">
                    <select class="form-select" [(ngModel)]="filtroEstado" (change)="aplicarFiltro()">
                      <option [ngValue]="null">Todos</option>
                      <option [ngValue]="1">Activos</option>
                      <option [ngValue]="0">Inactivos</option>
                    </select>
                  </div>
                  <div class="col-md-4 ms-auto">
                    <div class="input-group">
                      <input type="text" class="form-control"
                        placeholder="Buscar por nombre, tipo, riesgo, proceso o área..." [(ngModel)]="filtro"
                        (input)="aplicarFiltro()" />
                      <span class="input-group-text">
                        <i class="fa fa-search"></i>
                      </span>
                    </div>
                  </div>
                </div>

                <div *ngIf="!cargandoListado" class="table-responsive mt-2">
                  <ng-container *ngIf="programasFiltrados?.length > 0; else sinDatos">
                    <table id="tblProgramaPesv" class="table table-bordered table-hover align-middle">
                      <thead class="bg-primary text-white">
                        <tr>
                          <th class="text-center">CONSECUTIVO</th>
                          <th class="text-center">NOMBRE PROGRAMA</th>                         
                          
                          <!-- <th class="text-center">ÁREA</th> -->
                          <th class="text-center">FECHA INICIO</th>
                          <th class="text-center">FECHA FIN</th>
                          <th class="text-center">ESTADO</th>
                          <th class="text-center">ACCIONES</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="let programa of programasFiltrados | paginate: { itemsPerPage: pageSize, currentPage: page }">
                          <td class="text-center">{{ programa.consecutivo || '-' }}</td>                          
                          <td class="text-center">{{ programa.tipoProgramaData?.descripcion || '-' }}</td>
                        
                        
                          <td class="text-center">{{ programa.fecha_inicio | date:'dd/MM/yyyy' }}</td>
                          <td class="text-center">{{ programa.fecha_fin | date:'dd/MM/yyyy' }}</td>
                          <td class="text-center">
                            <span class="badge rounded-pill"
                              [ngClass]="programa.estado === 1 ? 'bg-success' : 'bg-secondary'">
                              {{ programa.estadoLabel }}
                            </span>
                          </td>
                          <td class="text-center">
                            <div class="d-flex justify-content-center gap-1">
                            
                              <button class="btn btn-sm btn-outline-dark rounded-pill btn-rounded"
                                ngbTooltip="Ver resumen"
                                (click)="abrirModalResumenPrograma(modalResumenPrograma, programa)">
                                <i class="icofont icofont-eye" style="font-size: .85rem;"></i>
                              </button>
                              <button class="btn btn-sm btn-outline-info rounded-pill btn-rounded"
                                ngbTooltip="Evidencias"
                                (click)="abrirModalDocumentos(modalDocumentosPrograma, programa)">
                                <i class="icofont icofont-cloud-upload" style="font-size: .85rem;"></i>
                              </button>
                              <button class="btn btn-sm btn-outline-secondary rounded-pill btn-rounded"
                                *ngIf="programa.estado !== 0" ngbTooltip="Seguimiento" (click)="Seguimientos(programa)">
                                <i class="icofont icofont-info" style="font-size: .85rem;"></i>
                              </button>
                              
                              <button class="btn btn-sm btn-outline-primary rounded-pill btn-rounded"
                                *ngIf="programa.estado === 1" ngbTooltip="Editar"
                                (click)="!cargandoEdicion && editarPrograma(programa)">
                                <i class="icofont icofont-pencil" style="font-size: .85rem;"></i>
                                <span class="spinner-border spinner-border-sm" *ngIf="cargandoEdicion"
                                  role="status"></span>
                              </button>
                              <button class="btn btn-sm btn-outline-secondary rounded-pill btn-rounded"
                                *ngIf="programa.estado === 1" ngbTooltip="Inactivar"
                                (click)="cambiarEstado(programa, 0)">
                                <i class="icofont icofont-trash" style="font-size: .85rem;"></i>
                              </button>
                              <button class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                                *ngIf="programa.estado !== 1" (click)="cambiarEstado(programa, 1)" ngbTooltip="Activar">
                                <i class="icofont icofont-check" style="font-size: .85rem;"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div class="d-flex justify-content-between align-items-center mt-4">
                      <div class="d-flex align-items-center">
                        <label for="pageSizeProgramas" class="me-2">Mostrar:</label>
                        <select id="pageSizeProgramas" class="form-select w-auto" [(ngModel)]="pageSize"
                          (change)="page = 1">
                          <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
                        </select>
                        <span class="ms-2">registros por página</span>
                      </div>

                      <div class="text-center flex-grow-1">
                        Total Registros:
                        <a class="badge badge-primary"><b>{{ programasFiltrados?.length || 0 }}</b></a>
                      </div>

                      <div class="text-end paginador-personalizado">
                        <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true"
                          [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls>
                      </div>
                    </div>

                    <div class="mt-4">
                      <div class="btn-showcase text-center">
                        <button class="btn btn-outline-success-2x" type="button" ngbTooltip="Exportar a Excel"
                          (click)="exportarExcel('tblProgramaPesv','listado_programa_pesv')">
                          <i class="icofont icofont-file-excel"></i> EXCEL
                        </button>
                        <button class="btn btn-outline-danger-2x" type="button" ngbTooltip="Exportar a PDF"
                          (click)="exportToPDF('tblProgramaPesv','listado_programa_pesv','Listado programas PESV')">
                          <i class="icofont icofont-file-pdf"></i> PDF
                        </button>
                      </div>
                    </div>
                  </ng-container>

                  <ng-template #sinDatos>
                    <div class="text-center py-4 text-primary">No hay programas registrados.</div>
                  </ng-template>
                </div>
              </div>
            </div>
          </ng-template>
        </li>
      </ul>

      <div [ngbNavOutlet]="programaTab" class="mt-2"></div>
    </div>
  </div>
</div>

<ng-template #modalEditarPrograma let-modal>
  <div class="modal-header bg-primary text-white">
    <h5 class="modal-title"><i class="icofont icofont-edit me-2"></i>Editar programa</h5>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <form [formGroup]="editarProgramaForm" novalidate>

      <!-- INFORMACIÓN GENERAL -->
      <div class="card border-0 shadow-sm mb-3">
        <div class="card-body">
          <h6 class="fw-bold text-primary mb-3">
            <i class="icofont icofont-info-circle me-2"></i>Información general
          </h6>

          <div class="row g-3">

            <!-- Nombre del programa -->
            <div class="col-md-4">
              <label class="form-label text-black">
                Nombre del programa: <span class="text-danger">*</span>
              </label>

              <div class="input-group">
                <ng-select class="flex-grow-1" [items]="nombresPrograma" bindLabel="descripcion" bindValue="id"
                  formControlName="nombrePrograma" [loading]="cargandoNombres" placeholder="Seleccione..."
                  [clearable]="true">
                </ng-select>

                <button class="btn btn-primary" type="button" (click)="abrirModal(modalCrearNombre)"
                  ngbTooltip="Crear nuevo nombre de programa">
                  <i class="icon-plus"></i>
                </button>
              </div>
            </div>

            <!-- Tipo programa -->
            <div class="col-md-4">
              <label class="form-label text-black">
                Tipo de programa: <span class="text-danger">*</span>
              </label>
              <div class="input-group">
                <ng-select class="flex-grow-1" [items]="tiposPrograma" bindLabel="descripcion" bindValue="id"
                  formControlName="tipoPrograma" placeholder="Seleccione..." [clearable]="true">
                </ng-select>

                <button class="btn btn-primary" type="button" (click)="abrirModal(modalCrearTipoPrograma)"
                  ngbTooltip="Crear nuevo tipo de programa">
                  <i class="icon-plus"></i>
                </button>
              </div>
            </div>

            <!-- Riesgo crítico -->
            <div class="col-md-4">
              <label class="form-label text-black">
                Riesgo crítico asociado: <span class="text-danger">*</span>
              </label>
              <div class="input-group">
                <ng-select class="flex-grow-1" [items]="riesgosCriticos" bindLabel="descripcion" bindValue="id"
                  formControlName="riesgoCriticoAsociado" placeholder="Seleccione..." [clearable]="true">
                </ng-select>

                <button class="btn btn-primary" type="button" (click)="abrirModal(modalCrearRiesgoCritico)"
                  ngbTooltip="Crear nuevo riesgo crítico">
                  <i class="icon-plus"></i>
                </button>
              </div>
            </div>

            <!-- Proceso -->
            <div class="col-md-4">
              <label class="form-label text-black">
                Proceso: <span class="text-danger">*</span>
              </label>
              <div class="input-group">
                <ng-select class="flex-grow-1" [items]="procesos" bindLabel="descripcion" bindValue="id"
                  formControlName="proceso" placeholder="Seleccione..." [clearable]="true">
                </ng-select>

                <button class="btn btn-primary" type="button" (click)="abrirModal(modalCrearProceso)"
                  ngbTooltip="Crear nuevo proceso">
                  <i class="icon-plus"></i>
                </button>
              </div>
            </div>

            <!-- Área -->
            <div class="col-md-4">
              <label class="form-label text-black">
                Área: <span class="text-danger">*</span>
              </label>
              <div class="input-group">
                <ng-select class="flex-grow-1" [items]="areas" bindLabel="descripcion" bindValue="id"
                  formControlName="area" placeholder="Seleccione..." [clearable]="true">
                </ng-select>

                <button class="btn btn-primary" type="button" (click)="abrirModal(modalCrearArea)"
                  ngbTooltip="Crear nueva área">
                  <i class="icon-plus"></i>
                </button>
              </div>
            </div>

            <!-- Objetivo PESV -->
            <div class="col-md-4">
              <label class="form-label text-black">
                Objetivo PESV relacionado <span class="text-danger">*</span>
              </label>
              <div class="input-group">
                <ng-select class="flex-grow-1" [items]="objetivosPesv" bindLabel="descripcion" bindValue="id"
                  formControlName="objetivoPesvRelacionado" placeholder="Seleccione..." [clearable]="true">
                </ng-select>

                <button class="btn btn-primary" type="button" (click)="abrirModal(modalCrearObjetivo)"
                  ngbTooltip="Crear nuevo objetivo">
                  <i class="icon-plus"></i>
                </button>
              </div>
            </div>


            <div class="col-md-4">
              <label class="form-label text-black text-secondary">Fecha inicio</label>
              <input type="date" class="form-control" [value]="programaEditando?.fecha_inicio || ''" readonly />
            </div>

            <div class="col-md-4">
              <label class="form-label text-black text-secondary">Fecha fin</label>
              <input type="date" class="form-control" [value]="programaEditando?.fecha_fin || ''" readonly />
            </div>

            <div class="col-md-12">
              <label class="form-label text-black">
                Objetivo general: <span class="text-danger">*</span>
              </label>
              <textarea class="form-control" rows="4" maxlength="2000" formControlName="objetivoGeneral"
                placeholder="Describa el objetivo general del programa"></textarea>
            </div>
            <small class="text-secondary">
              Máximo 2000 caracteres.
            </small>
          </div>
        </div>
      </div>

    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()"
      [disabled]="guardandoEdicion">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="guardarEdicion(modal)" [disabled]="guardandoEdicion">
      <span *ngIf="!guardandoEdicion"><i class="icofont icofont-save me-1"></i>Guardar cambios</span>
      <span *ngIf="guardandoEdicion">
        <span class="spinner-border spinner-border-sm me-1" role="status"></span>Guardando...
      </span>
    </button>
  </div>
</ng-template>

<ng-template #modalCrearNombre let-modal>
  <div class="modal-header bg-primary text-white">
    <h5 class="modal-title"><i class="icofont icofont-plus me-2"></i>Crear nuevo nombre de programa</h5>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <div class="mb-3">
      <label class="form-label text-black">Descripción del nombre <span class="text-danger">*</span></label>
      <input #descripcionInput type="text" class="form-control text-uppercase"
        placeholder="Ingrese la descripción..." />
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="crearNueveNombrePrograma(descripcionInput.value, modal)">
      <i class="icofont icofont-save me-1"></i>Crear nombre
    </button>
  </div>
</ng-template>

<ng-template #modalCrearTipoPrograma let-modal>
  <div class="modal-header bg-primary text-white">
    <h5 class="modal-title"><i class="icofont icofont-plus me-2"></i>Crear nuevo tipo de programa</h5>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <div class="mb-3">
      <label class="form-label text-black">Descripción del tipo <span class="text-danger">*</span></label>
      <input #descripcionInput type="text" class="form-control text-uppercase"
        placeholder="Ingrese la descripción..." />
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="crearNuevoTipoPrograma(descripcionInput.value, modal)">
      <i class="icofont icofont-save me-1"></i>Crear tipo
    </button>
  </div>
</ng-template>

<ng-template #modalCrearRiesgoCritico let-modal>
  <div class="modal-header bg-primary text-white">
    <h5 class="modal-title">
      <i class="icofont icofont-plus me-2"></i>
      Crear nuevo riesgo crítico
    </h5>
    <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()"></button>
  </div>

  <form [formGroup]="formTipoRiesgo">
    <div class="modal-body">
      <div class="mb-3">
        <label class="form-label text-black">
          Tipo de programa <span class="text-danger">*</span>
        </label>
        <ng-select [items]="tiposPrograma" bindLabel="descripcion" bindValue="id" formControlName="id_tipoprograma"
          placeholder="Seleccione..."
          [class.is-invalid]="formTipoRiesgo.get('id_tipoprograma')?.invalid && formTipoRiesgo.get('id_tipoprograma')?.touched">
        </ng-select>
      </div>

      <div class="mb-3">
        <label class="form-label text-black">
          Descripción <span class="text-danger">*</span>
        </label>
        <input type="text" class="form-control text-uppercase" formControlName="descripcion"
          placeholder="Ingrese la descripción"
          [class.is-invalid]="formTipoRiesgo.get('descripcion')?.invalid && formTipoRiesgo.get('descripcion')?.touched">
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancelar</button>
      <button type="button" class="btn btn-primary" (click)="crearNuevoRiesgoCritico(modal)">
        <i class="icofont icofont-save me-1"></i>Crear riesgo crítico
      </button>
    </div>
  </form>
</ng-template>

<ng-template #modalCrearProceso let-modal>
  <div class="modal-header bg-primary text-white">
    <h5 class="modal-title"><i class="icofont icofont-plus me-2"></i>Crear nuevo proceso</h5>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <div class="mb-3">
      <label class="form-label text-black">Descripción del proceso <span class="text-danger">*</span></label>
      <input #descripcionInput type="text" class="form-control text-uppercase"
        placeholder="Ingrese la descripción..." />
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="crearNuevoProceso(descripcionInput.value, modal)">
      <i class="icofont icofont-save me-1"></i>Crear proceso
    </button>
  </div>
</ng-template>

<ng-template #modalCrearArea let-modal>
  <div class="modal-header bg-primary text-white">
    <h5 class="modal-title"><i class="icofont icofont-plus me-2"></i>Crear nueva área</h5>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <div class="mb-3">
      <label class="form-label text-black">Descripción del área <span class="text-danger">*</span></label>
      <input #descripcionInput type="text" class="form-control text-uppercase"
        placeholder="Ingrese la descripción..." />
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="crearNuevoArea(descripcionInput.value, modal)">
      <i class="icofont icofont-save me-1"></i>Crear área
    </button>
  </div>
</ng-template>

<ng-template #modalCrearObjetivo let-modal>
  <div class="modal-header bg-primary text-white">
    <h5 class="modal-title"><i class="icofont icofont-plus me-2"></i>Crear nuevo objetivo</h5>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <div class="mb-3">
      <label class="form-label text-black">Descripción del objetivo <span class="text-danger">*</span></label>
      <input #descripcionInput type="text" class="form-control text-uppercase"
        placeholder="Ingrese la descripción..." />
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="crearNuevoObjetivo(descripcionInput.value, modal)">
      <i class="icofont icofont-save me-1"></i>Crear objetivo
    </button>
  </div>
</ng-template>

<ng-template #modalDocumentosPrograma let-modal>
  <div class="modal-header bg-primary text-white">
    <h5 class="modal-title">
      Documentos — Programa {{ programaSeleccionadoDocs?.consecutivo }}
    </h5>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">

    <!-- 🔒 Programa inactivo: no se permite cargar documentos -->
    <div class="alert alert-secondary d-flex align-items-center mb-4" *ngIf="programaSeleccionadoDocs?.estado === 0">
      <i class="icofont icofont-lock fs-5 me-2"></i>
      Este programa está <strong class="mx-1">inactivo</strong>, por lo tanto no se pueden cargar ni modificar
      documentos.
    </div>

    <div class="mb-4" *ngIf="programaSeleccionadoDocs?.estado !== 0">
      <input type="file" class="d-none" id="inputDocumentosPrograma" multiple (change)="onFileChangeDocumento($event)">
      <label for="inputDocumentosPrograma"
        class="dropzone-label w-100 d-flex flex-column align-items-center justify-content-center py-4 border border-primary rounded cursor-pointer">
        <i class="icofont icofont-upload fs-1 text-primary mb-2"></i>
        <p class="mb-2 text-black text-primary text-center">Haz click o arrastra archivos para cargar</p>
        <span class="btn btn-primary btn-sm rounded-pill px-3">Seleccionar archivos</span>
      </label>
    </div>

    <div *ngIf="nuevosArchivosDocs.length > 0 && programaSeleccionadoDocs?.estado !== 0" class="mb-4">
      <h6 class="fw-bold">Archivos seleccionados</h6>
      <div class="row g-2">
        <div class="col-6 col-md-3" *ngFor="let item of nuevosArchivosDocs; let i = index">
          <div class="card p-2 text-center h-100">
            <img *ngIf="item.preview" [src]="item.preview" class="mb-1 rounded"
              style="max-height: 90px; object-fit: cover;">
            <i *ngIf="!item.preview" class="fa fa-file-pdf-o fs-2 text-danger mb-1"></i>
            <small class="text-truncate d-block" [title]="item.file.name">{{ item.file.name }}</small>
            <button class="btn btn-sm btn-outline-danger mt-1" (click)="quitarArchivoNuevo(i)">
              <i class="bi bi-trash"></i> Quitar
            </button>
          </div>
        </div>
      </div>
      <button class="btn btn-success mt-3" [disabled]="subiendoDocumentos" (click)="subirDocumentosPlan()">
        <span *ngIf="subiendoDocumentos" class="spinner-border spinner-border-sm me-1"></span>
        <i class="icofont icofont-cloud-upload me-1"></i> Subir {{ nuevosArchivosDocs.length }} archivo(s)
      </button>
    </div>

    <hr>

    <h6 class="fw-bold text-dark">Documentos cargados</h6>
    <div *ngIf="cargandoDocumentos" class="text-center py-3">
      <div class="spinner-border text-primary"></div>
    </div>

    <div *ngIf="!cargandoDocumentos && documentosPlan.length === 0" class="text-primary text-center py-3">
      No hay documentos cargados para este programa.
    </div>

    <div class="row g-2" *ngIf="!cargandoDocumentos && documentosPlan.length > 0">
      <div class="col-12 col-md-4" *ngFor="let doc of documentosPlan">
        <div class="card p-2 text-center h-100">
          <img *ngIf="doc.isImage" [src]="doc.url" class="mb-1 rounded cursor-pointer"
            style="max-height: 90px; object-fit: cover;" (click)="verDocumento(modalVerDocumentoPrograma, doc)">
          <i *ngIf="!doc.isImage" class="fa fa-file-pdf-o fs-2 text-danger mb-1 cursor-pointer"
            (click)="verDocumento(modalVerDocumentoPrograma, doc)"></i>
          <small class="text-truncate d-block" [title]="doc.name">{{ doc.name }}</small>
          <div class="d-flex gap-1 justify-content-center mt-1">
            <button class="btn btn-sm btn-outline-primary" (click)="verDocumento(modalVerDocumentoPrograma, doc)">
              <i class="icofont icofont-eye"></i>
            </button>
            <button class="btn btn-sm btn-outline-warning" *ngIf="programaSeleccionadoDocs?.estado !== 0"
              (click)="reemplazarDocumento(doc)">
              <i class="icofont icofont-refresh"></i>
            </button>
            <button class="btn btn-sm btn-outline-danger" *ngIf="programaSeleccionadoDocs?.estado !== 0"
              (click)="eliminarDocumento(doc)">
              <i class="icon-trash"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Cerrar</button>
  </div>
</ng-template>

<ng-template #modalVerDocumentoPrograma let-modal>
  <div class="modal-body text-center" style="min-height: 60vh;">

    <img *ngIf="documentoSeleccionado?.isImage" [src]="documentoSeleccionado?.url" class="img-fluid rounded"
      style="max-height: 75vh;">

    <iframe *ngIf="documentoSeleccionado?.isPdf" [src]="documentoSeleccionado?.urlSegura"
      style="width: 100%; height: 75vh; border: none;">
    </iframe>

    <div *ngIf="!documentoSeleccionado?.isImage && !documentoSeleccionado?.isPdf"
      class="d-flex flex-column align-items-center justify-content-center py-5">
      <i class="fa fa-file-o fs-1 text-secondary mb-3"></i>
      <p class="text-primary">
        Este tipo de archivo no se puede previsualizar en el navegador.
      </p>
      <a [href]="documentoSeleccionado?.url" target="_blank" class="btn btn-primary">
        <i class="icofont icofont-download"></i> Descargar / Abrir
      </a>
    </div>

  </div>

  <div class="modal-footer">
    <a *ngIf="documentoSeleccionado?.isImage || documentoSeleccionado?.isPdf" [href]="documentoSeleccionado?.url"
      target="_blank" class="btn btn-outline-primary">
      <i class="icofont icofont-download"></i> Abrir en pestaña nueva
    </a>
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Cerrar</button>
  </div>
</ng-template>

<ng-template #modalResumenPrograma let-modal>
  <div class="modal-header bg-primary text-white">
    <div>
      <small class="d-block opacity-75">
        Paso 8 / Programas / {{ programaResumen?.consecutivo }} - {{ programaResumen?.nombreProgramaData?.descripcion }}
      </small>
      <h5 class="modal-title mb-0">
        <i class="icofont icofont-listine-dots me-2"></i>Resumen del programa
      </h5>
    </div>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body bg-light">

    <!-- 🔄 Loading -->
    <div *ngIf="cargandoResumen" class="text-center py-5">
      <div class="spinner-border text-primary" role="status"></div>
      <p class="mt-2 mb-0 text-secondary">Cargando resumen...</p>
    </div>

    <ng-container *ngIf="!cargandoResumen">

      <!-- 📋 Información general + Objetivo -->
      <div class="row g-3 mb-3">

        <div class="col-md-6">
          <div class="card h-100 border-0 shadow-sm">
            <div class="card-body">
              <h6 class="fw-bold mb-3 text-primary">
                <i class="icofont icofont-info-circle me-1"></i>Información General
              </h6>

              <div class="d-flex flex-column gap-2">

                <div class="d-flex justify-content-between align-items-center border-bottom pb-2">
                  <span class="text-secondary small">Nombre</span>
                  <span class="text-black text-end">{{ programaResumen?.nombreProgramaData?.descripcion || '-'
                    }}</span>
                </div>

                <div class="d-flex justify-content-between align-items-center border-bottom pb-2">
                  <span class="text-secondary small">Tipo</span>
                  <span class="text-black text-end">{{ programaResumen?.tipoProgramaData?.descripcion || '-' }}</span>
                </div>

                <div class="d-flex justify-content-between align-items-center border-bottom pb-2">
                  <span class="text-secondary small">Riesgo Crítico</span>
                  <span class="text-black text-end">{{ programaResumen?.tiposRiesgoVialData?.descripcion || '-'
                    }}</span>
                </div>

                <div class="d-flex justify-content-between align-items-center border-bottom pb-2">
                  <span class="text-secondary small">Fecha Inicio</span>
                  <span class="text-black">{{ programaResumen?.fecha_inicio | date:'dd/MM/yyyy' }}</span>
                </div>

                <div class="d-flex justify-content-between align-items-center border-bottom pb-2">
                  <span class="text-secondary small">Fecha Fin</span>
                  <span class="text-black">{{ programaResumen?.fecha_fin | date:'dd/MM/yyyy' }}</span>
                </div>

                <div class="d-flex justify-content-between align-items-center border-bottom pb-2">
                  <span class="text-secondary small">Estado</span>
                  <span class="badge rounded-pill"
                    [ngClass]="programaResumen?.estado === 1 ? 'bg-success-subtle text-success' : 'bg-secondary-subtle text-secondary'">
                    <i class="icofont icofont-check-circled me-1" *ngIf="programaResumen?.estado === 1"></i>
                    {{ programaResumen?.estadoLabel }}
                  </span>
                </div>

                <div class="pt-1">
                  <div class="d-flex justify-content-between mb-1">
                    <span class="text-secondary small">Avance General</span>
                    <span class="text-black small">{{ resumen.avanceGeneral }}%</span>
                  </div>
                  <div class="progress" style="height: 10px;">
                    <div class="progress-bar" [ngClass]="'bg-' + colorAvanceResumen(resumen.avanceGeneral)"
                      [style.width.%]="resumen.avanceGeneral"></div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <!-- 🎯 Objetivo general -->
        <div class="col-md-6">
          <div class="card h-100 border-0 shadow-sm">
            <div class="card-body d-flex flex-column">
              <h6 class="fw-bold mb-3 text-primary">
                <i class="icofont icofont-target-audience me-1"></i>Objetivo General
              </h6>
              <p class="mb-0 text-secondary" style="white-space: pre-line;">
                {{ programaResumen?.objetivo_general || 'Sin información registrada.' }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- 📊 Tarjetas de conteo -->
      <div class="row g-3 text-center">
      

       
        <div class="col-6 col-md">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body">
              <i class="icofont icofont-clock-time fs-4 text-primary d-block mb-1"></i>
              <div class="fs-3 fw-bold text-primary">{{ resumen.totalSeguimientos }}</div>
              <div class="text-secondary small">Seguimientos</div>
              <div class="text-secondary" style="font-size: 0.7rem;">
                Último: {{ resumen.ultimoSeguimiento ? (resumen.ultimoSeguimiento | date:'dd/MM/yyyy') : '-' }}
              </div>
            </div>
          </div>
        </div>

        <div class="col-6 col-md">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body">
              <i class="icofont icofont-file-document fs-4 text-primary d-block mb-1"></i>
              <div class="fs-3 fw-bold text-primary">{{ resumen.totalEvidencias }}</div>
              <div class="text-secondary small">Evidencias</div>
              <div class="text-secondary" style="font-size: 0.7rem;">Archivos</div>
            </div>
          </div>
        </div>

       

      </div>

    </ng-container>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Cerrar</button>
  </div>
</ng-template>

<!-- 🆕 Modal de Reportes -->
<!-- <ng-template #modalReportesPrograma let-modal>
  <div class="modal-header bg-primary text-white">
    <div>
      <small class="d-block opacity-75">
        Paso 8 / Programas / {{ programaReporteSeleccionado?.nombreProgramaData?.descripcion }} / Reportes
      </small>
      <h5 class="modal-title mb-0">
        <i class="icofont icofont-chart-bar-graph me-2"></i>Reportes del programa
      </h5>
    </div>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">

<div class="row g-3 align-items-end mb-4">
  <div class="col-md-3">
    <label class="form-label text-black">Tipo de Reporte</label>
    <select class="form-select" [(ngModel)]="reporteTipo" name="reporteTipo">
      <option value="resumen">Informe del Programa</option>
      <option value="indicadores">Indicadores</option>
      <option value="actividades">Actividades</option>
      <option value="evidencias">Evidencias</option>
      <option value="seguimientos">Seguimientos</option>
      <option value="evaluaciones">Evaluaciones</option>
    </select>
  </div>

  <div class="col-md-3">
    <label class="form-label text-black">Periodo</label>
    <select class="form-select" [(ngModel)]="reportePeriodo" name="reportePeriodo"
      (change)="aplicarPeriodoReporte()">
      <option *ngFor="let p of periodosReporte" [value]="p.id">{{ p.nombre }}</option>
    </select>
  </div>

  <div class="col-md-3">
    <label class="form-label text-black">Desde</label>
    <input type="date" class="form-control" [(ngModel)]="reporteDesde" name="reporteDesde"
      [min]="reporteFechaMinima" [max]="reporteHasta"
      [readonly]="reportePeriodo !== 'personalizado'">
  </div>

  <div class="col-md-3">
    <label class="form-label text-black">Hasta</label>
    <input type="date" class="form-control" [(ngModel)]="reporteHasta" name="reporteHasta"
      [min]="reporteDesde" [max]="reporteFechaMaxima"
      [readonly]="reportePeriodo !== 'personalizado'">
  </div>

  <div class="col-md-3 d-grid">
    <button class="btn btn-primary" type="button" (click)="generarReporte()">
      <i class="icofont icofont-file-pdf me-1"></i>Generar Reporte
    </button>
  </div>
</div>

<small class="text-secondary d-block mb-3">
  El rango está limitado entre {{ reporteFechaMinima | date:'dd/MM/yyyy' }} y {{ reporteFechaMaxima | date:'dd/MM/yyyy' }} (fechas del programa).
</small>

    <div class="row g-3">

      <div class="col-6 col-md-3">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-body text-center">
            <i class="icofont icofont-file-alt fs-2 text-primary mb-2"></i>
            <h6 class="fw-bold mb-1">Resumen Ejecutivo</h6>
            <p class="text-secondary small mb-3">Resumen general del programa</p>
            <button class="btn btn-outline-primary btn-sm" [disabled]="generandoReporte['resumen']"
              (click)="generarReporteResumenEjecutivo()">
              <span *ngIf="generandoReporte['resumen']" class="spinner-border spinner-border-sm me-1"></span>
              Generar PDF
            </button>
          </div>
        </div>
      </div>

      <div class="col-6 col-md-3">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-body text-center">
            <i class="icofont icofont-chart-line fs-2 text-primary mb-2"></i>
            <h6 class="fw-bold mb-1">Indicadores</h6>
            <p class="text-secondary small mb-3">Reporte de indicadores y metas</p>
            <button class="btn btn-outline-primary btn-sm" [disabled]="generandoReporte['indicadores']"
              (click)="generarReporteIndicadores()">
              <span *ngIf="generandoReporte['indicadores']" class="spinner-border spinner-border-sm me-1"></span>
              Generar PDF
            </button>
          </div>
        </div>
      </div>

      <div class="col-6 col-md-3">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-body text-center">
            <i class="icofont icofont-listine-dots fs-2 text-primary mb-2"></i>
            <h6 class="fw-bold mb-1">Actividades</h6>
            <p class="text-secondary small mb-3">Reporte de actividades</p>
            <button class="btn btn-outline-primary btn-sm" [disabled]="generandoReporte['actividades']"
              (click)="generarReporteActividades()">
              <span *ngIf="generandoReporte['actividades']" class="spinner-border spinner-border-sm me-1"></span>
              Generar PDF
            </button>
          </div>
        </div>
      </div>

      <div class="col-6 col-md-3">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-body text-center">
            <i class="icofont icofont-file-document fs-2 text-primary mb-2"></i>
            <h6 class="fw-bold mb-1">Evidencias</h6>
            <p class="text-secondary small mb-3">Listado de evidencias</p>
            <button class="btn btn-outline-primary btn-sm" [disabled]="generandoReporte['evidencias']"
              (click)="generarReporteEvidencias()">
              <span *ngIf="generandoReporte['evidencias']" class="spinner-border spinner-border-sm me-1"></span>
              Generar PDF
            </button>
          </div>
        </div>
      </div>

      <div class="col-6 col-md-3">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-body text-center">
            <i class="icofont icofont-history fs-2 text-primary mb-2"></i>
            <h6 class="fw-bold mb-1">Seguimientos</h6>
            <p class="text-secondary small mb-3">Histórico de seguimientos</p>
            <button class="btn btn-outline-primary btn-sm" [disabled]="generandoReporte['seguimientos']"
              (click)="generarReporteSeguimientos()">
              <span *ngIf="generandoReporte['seguimientos']" class="spinner-border spinner-border-sm me-1"></span>
              Generar PDF
            </button>
          </div>
        </div>
      </div>

      <div class="col-6 col-md-3">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-body text-center">
            <i class="icofont icofont-check-circled fs-2 text-primary mb-2"></i>
            <h6 class="fw-bold mb-1">Evaluaciones</h6>
            <p class="text-secondary small mb-3">Resultados de evaluaciones</p>
            <button class="btn btn-outline-primary btn-sm" [disabled]="generandoReporte['evaluaciones']"
              (click)="generarReporteEvaluaciones()">
              <span *ngIf="generandoReporte['evaluaciones']" class="spinner-border spinner-border-sm me-1"></span>
              Generar PDF
            </button>
          </div>
        </div>
      </div>

    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Cerrar</button>
  </div>
</ng-template> -->